import { motion } from 'framer-motion';

const Loading = () => {
  const dots = ['📚', '✨', '🌟', '🎨', '🦕'];

  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #E8F5E9 0%, #E3F2FD 35%, #EDE7F6 65%, #FFF8E1 100%)',
      }}
      exit={{
        y: -window.innerHeight,
        transition: { duration: 0.7, ease: 'easeInOut' }
      }}
    >
      {/* Background floating elements */}
      {['🌈', '⭐', '🎯', '🦋', '💫'].map((emoji, i) => (
        <motion.div
          key={i}
          className="absolute text-4xl opacity-20 pointer-events-none select-none"
          style={{
            left: `${10 + i * 20}%`,
            top: `${15 + (i % 3) * 25}%`,
          }}
          animate={{
            y: [0, -25, 0],
            rotate: [0, 15, -15, 0],
          }}
          transition={{
            duration: 3 + i * 0.5,
            repeat: Infinity,
            delay: i * 0.3,
          }}
        >
          {emoji}
        </motion.div>
      ))}

      {/* Main Logo */}
      <motion.div
        initial={{ scale: 0.5, opacity: 0, y: 30 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20,
          duration: 0.8,
        }}
        className="relative mb-8"
      >
        {/* Glow behind logo */}
        <motion.div
          className="absolute inset-0 rounded-full -z-10"
          style={{
            background: 'radial-gradient(circle, rgba(60,176,68,0.3) 0%, transparent 70%)',
            filter: 'blur(30px)',
            transform: 'scale(1.5)',
          }}
          animate={{ scale: [1.3, 1.7, 1.3], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 2.5, repeat: Infinity }}
        />

        <motion.img
          src="/logo.png"
          alt="The Tiny Times"
          className="w-auto h-28 md:h-36 object-contain drop-shadow-2xl"
          style={{ maxWidth: '340px' }}
          animate={{ scale: [1, 1.04, 1] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut', delay: 0.8 }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </motion.div>

      {/* Tagline */}
      <motion.p
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="text-lg md:text-xl font-display font-semibold mb-3"
        style={{ color: '#388E3C', letterSpacing: '0.02em' }}
      >
        ✨ Small Steps Into A Big World ✨
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        className="text-base text-neutral-gray-dark font-body mb-10"
      >
        Getting your weekly fun ready...
      </motion.p>

      {/* Loading bar */}
      <div className="relative w-72 md:w-80">
        {/* Track */}
        <div className="w-full h-3 bg-white/60 rounded-full overflow-hidden shadow-inner border border-white/40">
          <motion.div
            className="h-full rounded-full"
            style={{
              background: 'linear-gradient(90deg, #FF3B3B, #FF7F00, #F9C513, #3CB044, #1565C0, #7B2FBE)',
              backgroundSize: '200% 100%',
            }}
            initial={{ width: 0, backgroundPosition: '0% 0' }}
            animate={{ width: '100%', backgroundPosition: '200% 0' }}
            transition={{ duration: 2.2, ease: 'easeInOut' }}
          />
        </div>
      </div>

      {/* Bouncing dots */}
      <div className="flex gap-3 mt-10">
        {dots.map((dot, i) => (
          <motion.span
            key={i}
            className="text-2xl"
            animate={{ y: [0, -12, 0] }}
            transition={{
              duration: 0.7,
              repeat: Infinity,
              delay: i * 0.15,
            }}
          >
            {dot}
          </motion.span>
        ))}
      </div>
    </motion.div>
  );
};

export default Loading;